import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Users, Briefcase } from 'lucide-react';

export function RoleChoiceModal({ open, onOpenChange }) {
  const navigate = useNavigate();

  const dismiss = () => {
    localStorage.setItem('uclean_role_choice', 'v1');
    onOpenChange(false);
  };

  const handleUserChoice = () => {
    dismiss();
  };

  const handleProfessionalChoice = () => {
    dismiss();
    navigate('/profissionais/perfil');
  };

  // Closing the modal via X or Escape also dismisses permanently
  const handleOpenChange = (isOpen) => {
    if (!isOpen) dismiss();
    else onOpenChange(isOpen);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-2xl" data-testid="role-choice-modal">
        <DialogHeader>
          <DialogTitle className="text-2xl">Como você quer usar o U-Clean?</DialogTitle>
          <DialogDescription>
            Escolha a opção que melhor se adequa ao seu perfil. Você pode mudar isso depois.
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          {/* User Option */}
          <Card
            className="p-6 cursor-pointer hover:border-primary transition-colors"
            onClick={handleUserChoice}
            data-testid="user-choice-card"
            tabIndex={0}
            onKeyPress={(e) => e.key === 'Enter' && handleUserChoice()}
            role="button"
            aria-label="Sou usuário"
          >
            <div className="flex flex-col items-center text-center space-y-4">
              <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center">
                <Users className="h-8 w-8 text-blue-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">Sou Usuário</h3>
                <p className="text-sm text-muted-foreground">
                  Quero participar de grupos, reuniões e acessar conteúdo de apoio à recuperação.
                </p>
              </div>
              <Button variant="outline" className="w-full">
                Continuar como Usuário
              </Button>
            </div>
          </Card>

          {/* Professional Option */}
          <Card
            className="p-6 cursor-pointer hover:border-primary transition-colors"
            onClick={handleProfessionalChoice}
            data-testid="professional-choice-card"
            tabIndex={0}
            onKeyPress={(e) => e.key === 'Enter' && handleProfessionalChoice()}
            role="button"
            aria-label="Sou profissional"
          >
            <div className="flex flex-col items-center text-center space-y-4">
              <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
                <Briefcase className="h-8 w-8 text-green-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">Sou Profissional</h3>
                <p className="text-sm text-muted-foreground">
                  Sou terapeuta, psicólogo ou profissional da saúde e quero oferecer meus serviços.
                </p>
              </div>
              <Button className="w-full">
                Criar Perfil Profissional
              </Button>
            </div>
          </Card>
        </div>
      </DialogContent>
    </Dialog>
  );
}
